<script>
    import DatePeriod from "../date/DatePeriod.svelte";
    import EventLocationName from "./EventLocationName.svelte";
    import EventEditButton from "./EventEditButton.svelte";
    import EventImage from "./EventImage.svelte";
    import DateTimePeriod from "../date/DateTimePeriod.svelte";

    export let event;
</script>

<div class="container">
    <EventImage {event}/>
    <div class="image-gradient">
        <h1>{ event.name }</h1>
        <div class="date">
            <EventEditButton {event} form="date"/>
            <DateTimePeriod  periodFrom={event.event_from} periodTo={event.event_to}/>
            <EventLocationName {event}/>
        </div>
    </div>
</div>

<style>
    .container, img, h1 {
        margin: 0px;
        padding: 0px;
    }

    .container {
        position: relative;
        color: white;
    }

    img {
        display: block;
        width: 100%;
        height: auto;
    }

    .image-gradient {
        position: absolute;
        left: 0px;
        top: 0px;
        width: 100%;
        height: 100%;
        background: rgb(0, 0, 0);
        background: linear-gradient(0deg, rgba(0, 0, 0, 1) 35%, rgba(0, 0, 0, 0) 100%);
    }

    h1 {
        position: absolute;
        left: 10px;
        bottom: 75px;
        font-size: 20px;
    }

    .date {
        position: absolute;
        width: 95%;
        left: 10px;
        bottom: 10px;
        font-size: 14px;
    }
</style>